import { useMemo } from 'react';
import { countryOptions, COUNTRY_CODES } from '../lib/countries';

/** Pick a country by name; the value is its ISO 3166-1 alpha-2 code ('' = unknown). A stored
 *  value that is not an ISO code stays selectable, so editing a record never drops it silently. */
export function CountrySelect({ value, onChange, emptyLabel = 'unknown' }: { value: string; onChange: (code: string) => void; emptyLabel?: string }) {
  const options = useMemo(countryOptions, []);
  const v = value.trim().toUpperCase();
  return (
    <select value={v} onChange={(e) => onChange(e.target.value)}>
      <option value="">{emptyLabel}</option>
      {v && !COUNTRY_CODES.includes(v) && <option value={v}>{v} (not an ISO country code)</option>}
      {options.map(([code, name]) => (
        <option key={code} value={code}>
          {name} ({code})
        </option>
      ))}
    </select>
  );
}
